import React, { ComponentPropsWithRef, useCallback, useEffect, useState } from 'react';
import { EmblaCarouselType } from 'embla-carousel';
import { twMerge } from 'tailwind-merge';
import { Button } from '@/components/ui/button';

type UsePrevNextButtonsType = {
  prevBtnDisabled: boolean;
  nextBtnDisabled: boolean;
  onPrevButtonClick: () => void;
  onNextButtonClick: () => void;
};

export const usePrevNextButtons = (emblaApi: EmblaCarouselType | undefined): UsePrevNextButtonsType => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
  }, [emblaApi]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev());
    setNextBtnDisabled(!emblaApi.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onSelect(emblaApi);
    emblaApi.on('reInit', onSelect).on('select', onSelect);
  }, [emblaApi, onSelect]);

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  };
};

type PropType = ComponentPropsWithRef<'div'> & {
  icon: React.ReactNode;
  disabledIcon: React.ReactNode;
  disabled: boolean;
  className?: string;
};

export const NavButton: React.FC<PropType> = (props) => {
  const { disabled, icon, disabledIcon, className = '', ...restProps } = props;

  return (
    <div {...restProps} className={twMerge('bg-white ', className)}>
      <Button
        variant='secondary'
        className='h-full w-full bg-bg2-day hover:bg-bg2-day rounded-[12px]'
        type='button'
        disabled={disabled}
      >
        {disabled ? disabledIcon : icon}
      </Button>
    </div>
  );
};
